import { Typography } from '@mui/material';

import { Base02Title, GradientTitle, StyledButton } from './styled';

type ReverseGradientButtonProps = Omit<React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, 'children'> & {
  typoVarient?: 'h8' | 'h9';
  children?: string;
  isGradient?: boolean;
};

export default function ReverseGradientButton({ children, type, typoVarient = 'h9', isGradient = false, ...remainder }: ReverseGradientButtonProps) {
  return (
    <StyledButton {...remainder} type={type || 'button'}>
      {isGradient ? (
        <GradientTitle>
          <Typography variant={typoVarient}>{children}</Typography>
        </GradientTitle>
      ) : (
        <Base02Title>
          <Typography variant={typoVarient}>{children}</Typography>
        </Base02Title>
      )}
    </StyledButton>
  );
}
